const mobileDeviceRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const launchedInApp = /mobile/i.test(window.location.href);
const headerHidden = new URLSearchParams(window.location.search).get('header') === 'false';

export const isPhoneBrowser = () =>
  mobileDeviceRegex.test(window.navigator.userAgent) &&
  !launchedInApp &&
  !window.ReactNativeWebView;

export const shouldShowMobileWarning = () => isPhoneBrowser() && !headerHidden;
